import { useInfiniteQuery } from 'coreOld/hooks';
import { quoteHistoryService } from 'partsOld/services';
import { IQuoteHistory } from 'partsOld/types';

export const useGetQuoteHistory = (filters?) =>
  useInfiniteQuery<IQuoteHistory>(quoteHistoryService.getMany, 'quoteHistoryList', filters);
